import { Injectable } from '@angular/core';

import { BetslipPick } from '../../../../../../core/picks/betslip-pick';
import { AccaBoostFilter, AccaBoostSportConfig, CriteriaType, IRewardToken } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class AccaBoostGridGroupsValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.Market;

    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const filter = token.filter as AccaBoostFilter;
        const picks = state.selectedPicks;

        return picks.find((pick) => !filter.sportsConfigs[pick.sportId] || this.isNotValid(pick, filter.sportsConfigs[pick.sportId])) === undefined;
    }

    private isNotValid(pick: BetslipPick, sportConfig: AccaBoostSportConfig): boolean {
        const gridGroups = sportConfig.gridGroups;

        return Object.keys(gridGroups).length > 0 && !!pick.market?.gridGroups?.every((group) => !gridGroups[group]);
    }
}
